import { match } from 'ts-pattern';

export type PickButtonVariant = 'warning-fill' | 'primary-fill' | 'tertiary-fill';

export const getPickButtonVariant = (
  isActiveDirection: boolean,
  isAlternate: boolean
): PickButtonVariant =>
  match({ isActiveDirection, isAlternate })
    .with({ isActiveDirection: true, isAlternate: true }, () => 'warning-fill' as const)
    .with({ isActiveDirection: true, isAlternate: false }, () => 'primary-fill' as const)
    .with({ isActiveDirection: false }, () => 'tertiary-fill' as const)
    .exhaustive();
